<template>
  <el-form-item
    :label="label"
    class="remote-island-type"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="remoteIslandType"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :filter-method="filter"
    >
      <el-option label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <!-- <span style="float: left; color: #8492a6; font-size: 13px">{{item.value}}</span> -->
        <span style="float: left; margin-left: 10px">{{item.label}}</span>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '離島区分'
    },
    prop: {
      type: String,
      default: 'remote_island_type'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      options: []
    }
  },
  computed: {
    remoteIslandType: {
      get () {
        return this.value
      },
      set (remoteIslandType) {
        this.$emit('change', remoteIslandType)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const remoteIslandType = await this.loadCode()
    const remoteIslandTypeSet = remoteIslandType.map(function (index, array) {
      return { value: index.code_value, label: index.code_explanation }
    })
    this.options = remoteIslandTypeSet
  },
  methods: {
    async loadCode () {
      if (this.initialize) {
        await this.$axios
          .get('/code-master', { params: { code_id: 'REMOTE_ISLAND_TYPE' } })
          .then((res) => {
            sessionStorage.setItem('remoteIslandType', JSON.stringify(res.data.list))
          })
          .catch((e) => {
            console.log(e)
          })
      }
      return JSON.parse(sessionStorage.getItem('remoteIslandType'))
    }
  }
}
</script>

<style lang="scss" scoped>
.remote-island-type {
  ::v-deep .el-form-item__content {
    width: 12em;
  }
}
</style>
